import { request } from './api';
import config from '../config/index';
export default {
  /**
   * 获取红包优惠券营销工具内容
   * wiki: http://doc.phonebus.corpautohome.com/project/302/interface/api/42673
   * @param {dealerId, userId, deviceId, pcCookie, mobileCookie} param0
   */
  getRecommendRedPacket({
    dealerId,
    seriesId = 0,
    specId = 0,
    personalizedPush = false,
  }) {
    return request({
      type: 'get',
      url: `${config.dealerCloudVrapi}/vrapi/dealer/recommend/redPacket?_appid=dealervr`,
      data: { dealerId, seriesId, specId, personalizedPush },
      crossDomain: true,
      xhrFields: { withCredentials: true },
    });
  },
  /**
   * wiki: http://wiki.corpautohome.com/pages/viewpage.action?pageId=76634631
   * 获取经销商红包活动列表
   * @param {*} param0
   */
  getAvtivityListByDealerId({ dealerId }) {
    return request({
      type: 'get',
      dataType: 'json',
      url: config.baseUrl + 'ajax/GetAvtivityListByDealerId',
      data: { dealerid: dealerId },
    });
  },
  /**
   * //wiki: http://doc.phonebus.corpautohome.com/project/302/interface/api/8750
   * new wiki:http://doc.phonebus.corpautohome.com/project/302/interface/api/88200
   * 广告请求接口
   * @param {*} param0
   * @returns
   */
  getRecommendAd({
    dealerId,
    advId = 10001,
    orderDealerIds,
    cityId,
    seriesIds,
    limit,
    seriesId = 0,
    specId = 0,
    personalizedPush = false,
  }) {
    const url = `${config.dealerCloudArVr}/engine/v1/${advId}?appId=dealervr`;

    return request({
      type: 'get',
      dataType: 'json',
      url: url,
      data: {
        dealerId,
        seriesId: seriesId,
        specId: specId,
        personalizedPush,
        orderDealerIds,
        cityId,
        seriesIds,
        limit,
      },
      crossDomain: true,
      xhrFields: { withCredentials: true },
    });
  },
};
